import React, { useState } from "react";
import Swal from "sweetalert2";
import { ShieldCheck, ShieldX } from "react-bootstrap-icons";
import PPIService from "../../services/PPIService";
import PlatformFeesDialog from "./PlatformFeesDialog";

const KYC = ({ cardDetails, fetchCardDetails }) => {
  const [loading, setLoading] = useState(false);
  const [showPlatformFeesDialog, setShowPlatformFeesDialog] = useState(false);

  const initiateFullKycHandler = async () => {
    if (cardDetails?.full_kyc_fees_status !== "PAID") {
      getPlatformFees();
      return;
    }

    setLoading(true);
    try {
      const result = await PPIService.initiateFullKyc();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to initiate KYC", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        window.open(data.web_link, "_blank");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const [platformFees, setPlatFormFees] = useState("");

  const getPlatformFees = async () => {
    setLoading(true);
    try {
      const result = await PPIService.getPlatformFees();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Failed to initiate KYC", "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;

        setPlatFormFees(data.fees);
        setShowPlatformFeesDialog(true);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Request Failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {cardDetails && (
        <div className="card border-0 shadow-sm rounded-4 p-4">
          <h5 className="text-center mb-4 text-primary">
            Know Your Customer (KYC)
          </h5>

          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <strong>MIN KYC Status</strong>
            </div>
            <span className="badge bg-success px-3 py-2">
              <ShieldCheck className="me-1" /> Completed
            </span>
          </div>

          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <strong>FULL KYC Status</strong>
            </div>
            {cardDetails.full_kyc_status ? (
              <span className="badge bg-success px-3 py-2">
                <ShieldCheck className="me-1" /> Verified
              </span>
            ) : (
              <span className="badge bg-danger px-3 py-2">
                <ShieldX className="me-1" /> Not Verified
              </span>
            )}
          </div>

          {!cardDetails.full_kyc_status && (
            <div className="text-center mt-4">
              <button
                className="btn btn-primary px-4 py-2 rounded-pill"
                onClick={initiateFullKycHandler}
                disabled={loading}
              >
                {loading ? "Please wait..." : "Complete FULL KYC"}
              </button>
            </div>
          )}
        </div>
      )}

      <PlatformFeesDialog
        show={showPlatformFeesDialog}
        onHide={() => {
          setShowPlatformFeesDialog(false);
          fetchCardDetails();
        }}
        fees={platformFees}
      />
    </>
  );
};

export default KYC;
